<template>
  <div class="showMap">
    <div id="containerMap"></div>
    <div class="address">
      <div style="width:90%">
        <span class="label">当前位置：</span>
        <span class="value">{{addressObj.address}}</span>
        <span class="label">当前经纬度：</span>
        <span class="value">{{addressObj.lng}} , {{addressObj.lat}}</span>
      </div>
      <div style="margin-top: -10px;margin-bottom: 10px;">
        <el-button
          style="margin-left:20px"
          type="primary"
          @click="submit"
        >确定</el-button>
      </div>

    </div>
    <div class="inputBox">
      <CitySelectCom
        ref="cityNo"
        :IsAll="true"
        v-model="cityName"
      ></CitySelectCom>
      <el-input
        style="width:300px;margin:0 2px"
        id="pickerInput"
        placeholder="输入关键字选取地点"
        v-model="inputAdd"
      >
      </el-input>
      <el-button
        style="marginLeft:20px"
        type="primary"
        @click="getLng(inputAdd,false)"
      >搜索</el-button>
    </div>
    <div class="LabelBox">
      <div
        class="addressIcon"
        @click="GaodeMap()"
      >
        <i class="el-icon-map-location"></i>
      </div>
      <div
        :class="['addressIcon',zoomIndex>=18?'UnShow':null]"
        @click="getAmplification"
      >
        <i class="el-icon-plus"></i>
      </div>
      <div
        :class="['addressIcon',zoomIndex<=4?'UnShow':null]"
        @click="getNarrow"
      >
        <i class="el-icon-minus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import CitySelectCom from "./CitySelectCom";
export default {
  name: "showMap",
  components: {
    CitySelectCom,
  },
  data() {
    return {
      cityName: "全国",
      zoomIndex: 12,
      InfoWindow: null,
      icon: null,
      inputAdd: "",
      IsShowMap: false,
      mapAMap: null,
      geocoder: null,
      markerMap: null,
      PriData: {
        province: "",
        provinceNo: "",
        city: "",
        cityNo: "",
        district: "",
        districtNo: "",
      },
      PriArray: [],
    };
  },
  props: {
    allArea: {
      type: Array,
      default: function () {
        return [];
      },
    },
    addressObj: {
      type: Object,
      default:function() {
        return {
          address: "",
          lng: null,
          lat: null,
        }
      }
    },
  },
  computed: {
    // allArea: function() {
    //   return this.$store.state.globalAllArea;
    // }
  },
  created() {
    // this.GaodeMap();
  },
  mounted() {
    this.GaodeMap();
  },

  methods: {
    //确定
    submit() {
      // 高德地图api-查询行政区域编码
      this.getSearchAreaCode(this.PriData)
    },
    getSearchAreaCode (str ,type) {
      let that = this
      var map = new AMap.Map('containerMap', {
        // resizeEnable: true,
      });

      AMap.service('AMap.DistrictSearch',function(){//回调函数
        var opts = {};
        //实例化DistrictSearch
        var districtSearch = new AMap.DistrictSearch(opts);
        //使用districtSearch对象调用行政区查询的功能
        districtSearch.search(that.PriData.province,function(status, result){
          // 查询成功时，result即为对应的行政区信息
          if(result && result.info === 'OK' && result.districtList && result.districtList.length === 1) {
            that.PriData.provinceNo = result.districtList[0].adcode
            if(that.PriData.city) {
              districtSearch.search(that.PriData.city,function(status, result){
                // 查询成功时，result即为对应的行政区信息
                if(result && result.info === 'OK' && result.districtList && result.districtList.length > 0) {
                  var cityDistrictList = result.districtList
                  result.districtList.some(itemCity => {
                    if(itemCity.level === 'city' || itemCity.level === "province") {
                      that.PriData.cityNo = itemCity.adcode
                      districtSearch.search(that.PriData.district,function(status, result){
                        // 查询成功时，result即为对应的行政区信息
                        if(result && result.info === 'OK' && result.districtList && result.districtList.length > 0) {
                          // 校验重复的区名
                          result.districtList.forEach(item => {
                            if(item.citycode === itemCity.citycode) {
                              that.PriData.districtNo = item.adcode
                            }
                          })
                          // that.PriData.districtNo = result.districtList[0].adcode
                          if (that.PriData.province == "北京市") {
                            that.PriData.city = that.PriData.province
                            that.PriData.cityNo = "110100"
                          } else if(that.PriData.province == "天津市") {
                            that.PriData.city = that.PriData.province
                            that.PriData.cityNo = "120100"
                          } else if(that.PriData.province == "上海市") {
                            that.PriData.city = that.PriData.province
                            that.PriData.cityNo = "310100"
                          } else if(that.PriData.province == "重庆市") {
                            that.PriData.city = that.PriData.province
                            that.PriData.cityNo = "500100"
                          }
                          const obj = {
                            PriArray: that.PriArray,
                            PriData: that.PriData,
                            addressObj: that.addressObj,
                          };
                          that.$emit("mapArray", obj);
                        }
                      })
                    }
                  })
                }
              })
            } else {
              // 特殊地区city为空
              districtSearch.search(that.PriData.district,function(status, result){
                // 查询成功时，result即为对应的行政区信息
                if(result && result.info === 'OK' && result.districtList && result.districtList.length > 0) {
                  that.PriData.districtNo = result.districtList[0].adcode
                  //4个直辖市特殊处理-地图没有city
                  if (that.PriData.province == "北京市") {
                    that.PriData.city = that.PriData.province
                    that.PriData.cityNo = "110100"
                  } else if(that.PriData.province == "天津市") {
                    that.PriData.city = that.PriData.province
                    that.PriData.cityNo = "120100"
                  } else if(that.PriData.province == "上海市") {
                    that.PriData.city = that.PriData.province
                    that.PriData.cityNo = "310100"
                  } else if(that.PriData.province == "重庆市") {
                    that.PriData.city = that.PriData.province
                    that.PriData.cityNo = "500100"
                  }
                  const obj = {
                    PriArray: that.PriArray,
                    PriData: that.PriData,
                    addressObj: that.addressObj,
                  };
                  that.$emit("mapArray", obj);
                }
              })
            }
          }
        })
      })
    },
    changAddress(obj) {},
    //地理转换
    getLng(value, type) {
      var that = this;
      if (type) {
        //选择城市
        if (value == "全国" || !this.geocoder) {
          return;
        }
        const addressQ = `${value}市人民政府`;
        if (this.markerMap) {
          this.mapAMap.remove(this.markerMap);
        }
        this.geocoder.getLocation(addressQ, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            that.addressObj.address = result.geocodes[0].formattedAddress;
            that.addressObj.lng = result.geocodes[0].location.lng;
            that.addressObj.lat = result.geocodes[0].location.lat;
            that.PriData.province =
              result.geocodes[0].addressComponent.province;
            that.PriData.city = result.geocodes[0].addressComponent.city;
            that.PriData.district =
              result.geocodes[0].addressComponent.district;
            that.setCenter();
          } else {
            that.$message.error("根据地址查询经纬度失败");
          }
        });
      } else {
        //点击搜索
        if (!value) {
          that.$message.error("请输入关键字选取地点");
          return;
        }
        if (this.markerMap) {
          this.mapAMap.remove(this.markerMap);
        }
        const cityW = `${this.cityName}市${value}`;
        this.geocoder.getLocation(cityW, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            that.addressObj.address = result.geocodes[0].formattedAddress;
            that.addressObj.lng = result.geocodes[0].location.lng;
            that.addressObj.lat = result.geocodes[0].location.lat;
            that.PriData.province =
              result.geocodes[0].addressComponent.province;
              //省级下面县级市city为空（石河子市），
            that.PriData.city = result.geocodes[0].addressComponent.city? result.geocodes[0].addressComponent.city:  result.geocodes[0].addressComponent.district;
            that.PriData.district =
              result.geocodes[0].addressComponent.district;

            that.setCenter();
          } else {
            that.$message.error("根据地址查询经纬度失败");
          }
        });
      }
      // if (this.markerMap) {
      //   this.mapAMap.remove(this.markerMap);
      // }
      // var that = this;
      // this.geocoder.getLocation(inputAdd, function(status, result) {
      //   if (status === "complete" && result.geocodes.length) {
      //     that.addressObj.address = result.geocodes[0].formattedAddress;
      //     that.addressObj.lng = result.geocodes[0].location.lng;
      //     that.addressObj.lat = result.geocodes[0].location.lat;
      //     that.PriData.province = result.geocodes[0].addressComponent.province;
      //     that.PriData.city = result.geocodes[0].addressComponent.city;
      //     that.PriData.district = result.geocodes[0].addressComponent.district;

      //     that.setCenter();
      //   } else {
      //     that.$message.error("根据地址查询经纬度失败");
      //   }
      // });
    },
    setCenter() {
      var that = this;
      that.mapAMap.setCenter([that.addressObj.lng, that.addressObj.lat]);
      that.markerMap = new AMap.Marker({
        icon: that.icon,
        offset: new AMap.Pixel(-17, -40),
        // offset: new AMap.Pixel(-17, -20),
        position: new AMap.LngLat(that.addressObj.lng, that.addressObj.lat),
      });
      that.mapAMap.add(that.markerMap);

      that.infoWindow = new AMap.InfoWindow({
        content: that.addressObj.address, //传入 dom 对象，或者 html 字符串
      });
      that.infoWindow.open(
        that.mapAMap,
        new AMap.LngLat(that.addressObj.lng, that.addressObj.lat)
      );
    },
    //缩小
    getNarrow() {
      if (this.zoomIndex > 4) {
        this.zoomIndex = this.zoomIndex - 1;
        this.mapAMap.setZoom(this.zoomIndex);
      }
    },
    //放大
    getAmplification() {
      if (this.zoomIndex < 18) {
        this.zoomIndex = this.zoomIndex + 1;
        this.mapAMap.setZoom(this.zoomIndex);
      }
    },
    //初始化高德地图
    GaodeMap() {
      var that = this;
      this.mapAMap = new AMap.Map("containerMap", {
        resizeEnable: true,
        showIndoorMap: false, //关闭室内地图
        zoom: 12,
      });
      that.icon = new AMap.Icon({
        size: new AMap.Size(32, 42), // 图标尺寸
        image: require("../../static/img/position_firstred1.png"), // Icon的图像
        imageOffset: new AMap.Pixel(2, 2), // 图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new AMap.Size(30, 42), // 根据所设置的大小拉伸或压缩图片
      });
      // this.geocoder = new AMap.Geocoder({});
      AMap.plugin("AMap.Geocoder", function () {
        that.geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        });
      });
      AMap.plugin("AMap.Geolocation", function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: "RB", //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          showButton: false,
          markerOptions: {
            //自定义定位点样式，同Marker的Options
            offset: new AMap.Pixel(-18, -36),
            content:
              '<img src="https://a.amap.com/jsapi_demos/static/resource/img/user.png" style="width:36px;height:36px"/>',
          },
          circleOptions: {
            //定位精度圈的样式
            strokeColor: "#0093FF",
            noSelect: true,
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: "#02B0FF",
            fillOpacity: 0.25,
          },
        });
        that.mapAMap.addControl(geolocation);
        if(that.addressObj.lng && that.addressObj.lat) {
          that.setCenter()
          that.regeoCode()
        } else {
          geolocation.getCurrentPosition(function (status, result) {
            if (status == "complete") {
              //获得成功
              that.mapAMap.setZoomAndCenter(10, [
                result.position.lng,
                result.position.lat,
              ]);
              that.addressObj.lng = result.position.lng;
              that.addressObj.lat = result.position.lat;
              that.regeoCode();
            } else {
            }
          });
        }
      });
      this.mapAMap.on("click", function (e) {
        that.addressObj.lng = e.lnglat.lng;
        that.addressObj.lat = e.lnglat.lat;
        if (that.infoWindow) {
          // that.infoWindow.close(that.mapAMap);
        }
        that.regeoCode();
      });
    },
    //查询地址
    regeoCode() {
      if (this.markerMap) {
        this.mapAMap.remove(this.markerMap);
      }
      var that = this;
      this.geocoder.getAddress(
        [that.addressObj.lng, that.addressObj.lat],
        function (status, result) {
          if (status === "complete" && result.regeocode) {
            let province=result.regeocode.addressComponent.province
            that.addressObj.address = result.regeocode.formattedAddress;
            that.PriData.province = province;
            if(result.regeocode.addressComponent.city || province =="北京市" || province =="上海市" || province =="天津市" || province =="重庆市" ){
              that.PriData.city = result.regeocode.addressComponent.city;
              //处理省下的县级市，例如新疆石河子市
            }else if(province !="北京市" || province !="上海市" || province !="天津市" || province !="重庆市" ){
              that.PriData.city = result.regeocode.addressComponent.district;
            }
            that.PriData.district = result.regeocode.addressComponent.district;
          } else {
            that.$message.error("根据经纬度查询地址失败");
          }
          that.setCenter();
        }
      );
    },
    //设置地点
    setAddress(city) {
      var that = this;
      if (that.UiContent) {
        this.poiPicker.setCity(city);
        that.poiPickerReady(that.poiPicker);
      } else {
        //   样式;
        AMapUI.loadUI(["misc/PoiPicker"], function (PoiPicker) {
          that.UiContent = PoiPicker;
          that.poiPicker = new PoiPicker({
            city: city,
            input: "pickerInput",
          });
          //初始化poiPicker
          that.poiPickerReady(that.poiPicker);
        });
      }
    },
    //
    poiPickerReady(poiPicker) {
      var that = this;
      //选取了某个POI
      poiPicker.on("poiPicked", function (poiResult) {
        if (poiResult.source == "suggest") {
          const addressT = `${poiResult.item.district}${poiResult.item.address}${poiResult.item.name}`;
          // that.inputAdd = poiResult.item.name;
          that.addressObj.address = addressT;
          that.addressObj.lng = poiResult.item.location.lng;
          that.addressObj.lat = poiResult.item.location.lat;
        } else if (poiResult.source == "search") {
          const addressT = `${poiResult.item.pname}${poiResult.item.cityname}${poiResult.item.adname}${poiResult.item.address}${poiResult.item.name}`;
          // that.inputAdd = poiResult.item.name;
          that.addressObj.address = addressT;
          that.addressObj.lng = poiResult.item.location.lng;
          that.addressObj.lat = poiResult.item.location.lat;
        }
        // that.setCenter();
        that.regeoCode();
      });
      poiPicker.onCityReady(function (res) {
        if (that.inputAdd) {
          poiPicker.suggest(that.inputAdd);
        }
      });
    },
  },
  watch: {
    cityName: {
      handler(nVal) {
        if (nVal) {
          this.getLng(nVal, true);
          this.setAddress(nVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mixins: [],
  filters: {},
};
</script>

<style lang="scss" scoped>
.showMap {
  position: relative;
  #containerMap {
    height: 400px;
    width: 100%;
  }
  .address {
    /*width: 100%;*/
    display: flex;
    margin: 20px;
    font-size: 14px;
    .label {
      color: #666;
      margin: 0 10px;
    }
    .value {
      color: #0286df;
    }
  }
  .inputBox {
    position: absolute;
    top: 40px;
    right: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .LabelBox {
    border: 1px solid #ddd;
    position: absolute;
    z-index: 2;
    bottom: 160px;
    right: 40px;
    background: #ffffff;
    font-size: 14px;
    font-size: 24px;
    cursor: pointer;
    .addressIcon {
      padding: 5px 10px;
      border-bottom: 1px solid #f1f1f1;
      &:nth-child(3) {
        border-bottom: none;
      }
    }
    .UnShow {
      color: #999;
    }
  }
}
</style>
<style lang="scss">
.showMap {
  .el-input.is-disabled .el-input__inner {
    background-color: white;
    border-color: white;
    color: #c0c4cc;
  }
  .is-disabled {
    background-color: white;
    border-color: white;
    color: #c0c4cc;
    :hover {
      cursor: pointer !important;
    }
  }
}
</style>
